module.exports = __webpack_public_path__ + "img/airplane-5.ddad7aa6.jpg";